import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f6d91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing course-details-card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body p-10\" data-v-27f6d91c><div class=\"bg-gradient ps-15 pe-15 pt-20 pb-20 ps-md-30 pe-md-30 pt-md-30 pb-md-30 ps-lg-40 pe-lg-40 pt-lg-40 pb-lg-40\" data-v-27f6d91c><div class=\"course-details-header\" data-v-27f6d91c><span class=\"d-inline-block bg-warning fs-12 fw-medium rounded-1 ps-10 pe-10 pt-1 pb-1 mb-10 text-black\" data-v-27f6d91c> Asignación académica </span><h2 class=\"fw-bold text-white\" data-v-27f6d91c>Preescolar — Asignación por grupo</h2><p class=\"lh-base fs-md-15 fs-lg-16\" data-v-27f6d91c> Selecciona los docentes asignados a cada grupo de preescolar. </p><div class=\"info d-sm-flex align-items-center\" data-v-27f6d91c><div class=\"reviews d-flex align-items-center\" data-v-27f6d91c><div class=\"rating lh-1\" data-v-27f6d91c><i class=\"flaticon-star-1\" data-v-27f6d91c></i><i class=\"flaticon-star-1\" data-v-27f6d91c></i><i class=\"flaticon-star-1\" data-v-27f6d91c></i><i class=\"flaticon-star-1\" data-v-27f6d91c></i><i class=\"flaticon-star-1\" data-v-27f6d91c></i></div><span class=\"fw-bold fs-13 ms-5 me-8 text-white\" data-v-27f6d91c>Vista árbol</span><span data-v-27f6d91c>Grupos → Docentes</span></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-10 pb-10 ps-10 pe-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Sede", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Año académico", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Grupo", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Docente", -1))
const _hoisted_8 = { class: "pe-xxl-25 pe-xxxl-50" }
const _hoisted_9 = { class: "card-body pt-0 pb-0 ps-10 pe-10" }
const _hoisted_10 = {
  class: "accordion",
  id: "groupsAccordion"
}
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_15 = { class: "ms-10" }
const _hoisted_16 = { class: "text-muted ms-10" }
const _hoisted_17 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_18 = { class: "position-relative fw-medium fs-13 text-muted me-15" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "fw-semibold" }
const _hoisted_24 = { class: "text-muted fs-12" }
const _hoisted_25 = {
  key: 0,
  class: "text-muted fs-13"
}
const _hoisted_26 = {
  key: 0,
  class: "text-muted fs-14 mt-10"
}
const _hoisted_27 = { class: "card-body pt-10 pb-15 ps-10 pe-10" }
const _hoisted_28 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_b_row, { class: "g-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.headquarterId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.headquarterId) = $event)),
                    options: _ctx.headquarterOptions,
                    placeholder: "Todas las sedes"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.academicYearId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.academicYearId) = $event)),
                    options: _ctx.academicYearOptions,
                    placeholder: "Todos los años"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.courseGroupId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.courseGroupId) = $event)),
                    options: _ctx.groupOptions,
                    placeholder: "Todos los grupos"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.teacherId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.teacherId) = $event)),
                    options: _ctx.teacherOptions,
                    disabled: _ctx.isEditing,
                    placeholder: "Todos los docentes"
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsForTree, (grp, gIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: grp.Id,
              class: "accordion-item border-0"
            }, [
              _createElementVNode("button", {
                class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fw-medium rounded-0 bg-white border-0",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#grp-${grp.Id}`,
                "aria-controls": `grp-${grp.Id}`
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(gIdx + 1), 1),
                    _createElementVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(grp.Name || ('Grupo ' + grp.Id)) + " ", 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(grp.CourseName || 'N/D') + " - " + _toDisplayString(grp.HeadquarterName || 'Sin sede') + " - " + _toDisplayString(grp.AcademicYearName || 'N/D'), 1)
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_17, [
                    _createElementVNode("li", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.teacherCountForGroup(grp.Id)) + " docentes asignados ", 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_11),
              _createElementVNode("div", {
                id: `grp-${grp.Id}`,
                class: "accordion-collapse collapse",
                "data-bs-parent": "#groupsAccordion"
              }, [
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachersForUI, (tch) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tch.Id,
                      class: "d-flex justify-content-between align-items-center py-6 border-bottom ps-4"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_b_form_checkbox, {
                          class: "me-8",
                          "model-value": _ctx.isAssigned(grp, tch),
                          variant: _ctx.isAssigned(grp, tch) ? 'success' : 'secondary',
                          "onUpdate:modelValue": (val) => _ctx.onToggleAssignment(grp, tch, val)
                        }, null, 8, ["model-value", "variant", "onUpdate:modelValue"]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.teacherLabel(tch)), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(tch.IdentificationNumber), 1)
                        ])
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", _ctx.isAssigned(grp, tch) ? 'bg-success' : 'bg-secondary'])
                      }, _toDisplayString(_ctx.isAssigned(grp, tch) ? 'Asignado' : 'Sin asignar'), 3)
                    ]))
                  }), 128)),
                  (!_ctx.teachersForUI.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No hay docentes según el filtro. "))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_20)
            ]))
          }), 128)),
          (!_ctx.groupsForTree.length && !_ctx.table.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, " No hay grupos que cumplan los filtros. "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_b_button, {
          variant: "success",
          class: "default-btn transition border-0 fw-medium text-white py-10 px-25 rounded-1 fs-14",
          disabled: !_ctx.canRegister || _ctx.table.loading,
          onClick: _ctx.onRegisterAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Registrar asignaciones ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}